import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/CulturePage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { jobs_helper } from "@/helpers/jobs_helper";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = insights_helper.fetch();
  const jobs = jobs_helper.fetch({
    filter: (i) => JSON.stringify(i.categories).includes(sourceflowEnums.categories.sectors.internal),
  });

  const routerProp = router["careers"];
  const titleKey = "page.culture.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "CulturePageBannerSection" },
        { component: "CulturePageContentSection" },
        { component: "CulturePageRewardsSection" },
        { component: "ValuesSection", props: { variant: "quaternary", tags: "Culture" } },
        { component: "CulturePageValueSection" },
        { component: "CulturePageGreatSection" },
        {
          component: "CommitteeSection",
          props: { variant: "quaternary", quoteBlockClasses: "bg-tertiary text-white" },
        },
        {
          component: "InsightsSection",
          props: {
            title: { path: "page.culture.insights.title" },
            variant: "quaternary",
            cardVariant: "quaternary",
            cardBtnVariant: "quinary",
            items: insights,
            sidebar: true,
          },
        },
        {
          component: "LatestJobsSection",
          props: {
            variant: "quaternary",
            cardVariant: "quaternary",
            cardBtnVariant: "quinary",
            items: jobs,
            jobsUrl: "/join-us/jobs",
          },
        },
        { component: "CulturePageOfficesSection" },
        { component: "AwardsSection", props: { variant: "quaternary" } },
      ],
    },
  };
}
